
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-sm font-semibold text-gray-500 tracking-widest uppercase mb-3">About Us</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">東京支部について</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              東京支部は、首都圏のライブハウスとアーティストを結び、地域の音楽文化を継続的に育てるための実務組織です。支部は現場に近い立場で「公演の成立」「販売の管理」「広報の実行」を担い、会場が育成と当日の運営に専念できる環境を作ります。
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              東京支部は「会場が現場の主役」であることを尊重します。まずは試験的な連携から始め、地域の実情に合わせて運用ルールを調整していきます。ご不明点や参加希望は支部窓口までお気軽にご相談ください。
            </p>

            <div className="bg-gray-50 rounded-lg p-6 mb-8">
              <h3 className="text-lg font-bold text-gray-900 mb-4">主な役割</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-gray-900"></i>
                  </div>
                  <span className="text-gray-600 text-sm">会場スケジュールの取りまとめと調整</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-gray-900"></i>
                  </div>
                  <span className="text-gray-600 text-sm">出演者の登録管理と配分（目安：1アーティスト 月5回程度）</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-gray-900"></i>
                  </div>
                  <span className="text-gray-600 text-sm">チケット登録（Eプラス等）と販売運営（公演の1ヶ月前に登録）</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-gray-900"></i>
                  </div>
                  <span className="text-gray-600 text-sm">広報支援（SNS告知は原則2週間前開始）</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-gray-900"></i>
                  </div>
                  <span className="text-gray-600 text-sm">自治体・商工会等との連携窓口対応</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-gray-50 rounded-lg p-8">
              <h3 className="text-lg font-bold text-gray-900 mb-6">参加方法</h3>
              
              <div className="space-y-6">
                <div>
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-lg flex-shrink-0">
                      <i className="ri-building-line text-lg"></i>
                    </div>
                    <h4 className="font-semibold text-gray-900">ライブハウス</h4>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed pl-13">
                    支部登録後、各会場のスケジュールを支部カレンダーへ登録してください。
                  </p>
                </div>

                <div>
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-lg flex-shrink-0">
                      <i className="ri-mic-line text-lg"></i>
                    </div>
                    <h4 className="font-semibold text-gray-900">アーティスト</h4>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed pl-13">
                    参加希望の会場を通じて登録手続きを行ってください。
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-calendar-line text-2xl text-gray-900"></i>
                </div>
                <p className="text-3xl font-bold text-gray-900 mb-1">2018</p>
                <p className="text-sm text-gray-500">設立年</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-building-line text-2xl text-gray-900"></i>
                </div>
                <p className="text-3xl font-bold text-gray-900 mb-1">6</p>
                <p className="text-sm text-gray-500">加盟会場</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mic-line text-2xl text-gray-900"></i>
                </div>
                <p className="text-3xl font-bold text-gray-900 mb-1">50+</p>
                <p className="text-sm text-gray-500">登録アーティスト</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-music-2-line text-2xl text-gray-900"></i>
                </div>
                <p className="text-3xl font-bold text-gray-900 mb-1">200+</p>
                <p className="text-sm text-gray-500">年間イベント数</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
